// recon-helpers-messages (no catalog).
window.PlummeI18n.register('no', {
  'rcx.loan.class.accruedInterest': 'Påløpt rente',
  'rcx.loan.class.unbookedPrincipal': 'Ikke bokført avdrag',
  'rcx.loan.class.unbookedFee': 'Ikke bokført gebyr',
  'rcx.loan.class.timing': 'Tidsavvik',
  'rcx.loan.class.fxDifference': 'Valutadifferanse',
  'rcx.loan.class.wrongLedger': 'Feil hovedbokskonto',
  'rcx.loan.class.wrongTerm': 'Feil kortsiktig/langsiktig klassifisering',
  'rcx.loan.class.missingDocs': 'Manglende dokumentasjon',
  'rcx.loan.class.other': 'Annet',
});
